'use strict';

var values = require('../helpers/values');

module.exports = function every(fn) {
  var items = values(this.items);

  return items.every(fn);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/every.js
// module id = 51yO
// module chunks = 0